// extracted by mini-css-extract-plugin
export default {"container":"DealStatusWithIcon_container__Hg0q7","icon":"DealStatusWithIcon_icon__e-bF0"};